
/*
usage:
domready(app_init);

The 'app_init' will execute when dom state is 'interactive' or 'complete'.
if  is enabled the initial load has to be done after readyState is ok.
If the  configuration does not dispatch 'loading' the 'isViewable' check is used as fallback.
*/

import domReady from './../../../../utils/dom-ready.js';

const applyWhenDomIsReady = function (func) {

	(function pollCheck() {
		const state = document.readyState;
		if (state === 'interactive' || state === 'complete') {
			func();
		} else {
			setTimeout(pollCheck, 200);
		}
	}());
};


export default {
	run(func) {
		if (typeof func === 'function') {
			domReady.then(() => func());
		} else {
			console.error(`domready: argument must be a function: ${func}`);
		}
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/domready.js